export default __webpack_public_path__ + "static/media/gold_image_2.3a2b5786.jpg";